import http from "../../utils/http"

/**
 * 获取客户签到功能状态
 */
export function getSignStatus(params) {
    return http({
        url: "/api/membersignin/getSignStatus",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取签到周期与奖励规则
 */
export function getSignAward(params) {
    return http({
        url: "/api/membersignin/award",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取今日签到状态
 */
export function getIsSign(params) {
    return http({
        url: "/api/membersignin/issign",
        data: params,
        forceLogin: true
    })
}

/**
 * 提交签到
 */
export function submitSignin(params) {
    return http({
        url: "/api/membersignin/signin",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取签到累计积分或成长值
 */
export function getSigninAccountSum(params) {
    return http({
        url: "/api/memberaccount/sum",
        data: params,
        forceLogin: true
    })
}
